import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image1 from "../../../../assets/images/Blog33/image1.png";
import image2 from "../../../../assets/images/Blog33/image2.png";
import image5 from "../../../../assets/images/Blog33/image5.png";
import image6 from "../../../../assets/images/Blog33/image6.png";
import image9 from "../../../../assets/images/Blog33/image9.png";
import image10 from "../../../../assets/images/Blog33/image10.png";
import image8 from "../../../../assets/images/Blog33/image8.png";

const Blog33 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – September 8th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Fed Cuts, Gold Breakouts & September’s Seasonal Chop</p>
        <p>
          Markets stumble into September—the seasonally weakest month—caught between softening labour data, Fed cut speculation, and commodity breakouts. Traders are weighing whether “bad news is good
          news,” but volatility looms large as macro cracks widen.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Flat Jobs, Rising Risks</p>
              <p>
                Friday’s <span className="highlightedText">jobs data </span> rattled sentiment. June was revised negative for the first time since 2020, while July’s downgrade erased August’s modest
                +22k gain. Net impact: the labour market is flat.
              </p>
              <p>
                Equities initially popped but quickly sold off, underscoring the market’s indecision. Retail optimism clashes with institutional caution—positioning is light, but volatility is
                creeping.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    Fed odds shift: 10% chance of a <span className="highlightedText">50bp cut </span>this month, consensus remains 25bp in September and October.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Gold surges to fresh ATHs, but short-term momentum looks stretched.</p>
                </li>
                <li className="themesPointer">
                  <p>Oil’s “glut” narrative is cracking—supply could tighten fast.</p>
                </li>
                <li className="themesPointer">
                  <p>Equities remain in uptrends, but corrections are likely before Q4 catch-up.</p>
                </li>
              </ul>
              <div className="relatedImg">
                <img
                  src={image1}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image1)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Fed Behind the Curve</p>
              <p>The Fed is back in focus. Last week’s jobs data confirms a deterioration that Powell can use as cover for easing. But the debate is not about when cuts begin—it’s how much.</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    Market expects
                    <span className="highlightedText"> 3–4 cuts by year-end, </span> totalling 75–100bps.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>The risk: a 50bp “panic cut” spooks confidence, triggering outflows despite equity optimism.</p>
                </li>
                <li className="themesPointer">
                  <p>
                    Consensus:<span className="highlightedText"> 25bp September, 25bp October,</span> but the Fed has a history of moving decisively once it starts cutting.
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">Global watchpoints:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">France: </span>Another confidence vote looms, keeping capital outflows in play.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Ishiba’s exit tilts policy dovish, raising spending expectations.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> UK: </span>Labour’s anti-growth policies risk driving capital flight, though GBP holds steady near $1.335–1.360.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> China: </span> CPI/PPI data Wednesday—deflationary prints could force stimulus; disappointment may trigger risk-off.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Key Setups</p>
              <p className="highlightedText">Gold – Breakout Confirmed, but Overheated</p>
              <p>
                Gold has smashed into a new ATH, confirming the <span className="highlightedText">impulse wave breakout</span> we flagged months ago. Seasonality (India, Christmas, China) plus macro
                drivers (weak dollar, safe-haven demand, fiscal expansion) reinforce the bullish case.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Medium-term target: </span>$4k by year-end.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Short-term: </span> Price is hugging Bollinger Bands, with fading MACD momentum. A pullback is overdue.
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="contentDiv listOfRecap">
              <p className="highlightedText">Oil – Supply Story Flips</p>
              <p>
                Talk of oversupply masks deeper tightening pressures. Russia’s sanctions and China’s strategic reserve building drain supply, leaving
                <span className="highlightedText"> Saudi Arabia as the only true swing producer.</span> This setup risks a<span className="highlightedText"> commodity breakout </span>that could
                reintroduce inflationary pressures by 2026.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="contentDiv listOfRecap">
              <p className="highlightedText">NAS100 – Wave (4) Consolidation in Play</p>
              <p>
                The August top played out as expected, with last week’s rejection reinforcing the
                <span className="highlightedText"> wave (4) pullback </span>narrative. The <span className="highlightedText"> 38.2% Fibonacci retrace </span>looks like the probable termination
                level—aligning with seasonality. An alternative setup opens if ATHs are breached.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="contentDiv listOfRecap">
              <p className="highlightedText">Volatility – Calm Before the Spike</p>
              <p>
                Both MOVE and VIX remain subdued, suggesting a “wait and see” market. But any downside will likely be driven by a<span className="highlightedText"> MOVE spike, </span>bleeding into
                equity volatility.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: From Jobs to Jitters</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">NFP: </span>Net zero growth after revisions; June marked the first negative print since 2020.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span> Friday rally faded—Fed seen as behind the curve.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold: </span>Breakout delivered, with fresh ATH momentum.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil: </span> Conflicting narratives intensify—oversupply vs. tightening.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Volatility:</span> Held steady, but traders braced for spikes.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Inflation & Central Banks</p>

              <p className="highlightedText">Monday, Sep 8</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Quiet open; positioning carries over from NFP shock.</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, Sep 9</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US NFP benchmark revision – </span> last year’s came in at -598k; a large negative could shake confidence.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, Sep 10</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China CPI/PPI –</span>all eyes on deflationary pressures and policy response.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US PPI –</span> tariff impacts and services inflation in focus.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, Sep 11</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US CPI –</span> the marquee release; softer prints revive 50bp cut debate.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">ECB rate decision –</span> expected on hold, hawks and doves split.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, Sep 12</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone final CPI –</span> confirmation data for the ECB.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK GDP/activity data –</span> slowdown from June’s upbeat surprise expected.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UoM surveys & inflation expectations –</span> key sentiment wrap to close the week.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Trade the Chop, Don’t Fear It</p>
              <p>The Fed is boxed in—cuts are coming, the only question is pace. Equities remain in uptrends, but September chop is real. Expect selective opportunities rather than broad melt-ups.</p>
              <p>
                <span className="highlightedText">Our stance:</span>
              </p>
              <ul className="pointersSection">
                <li className="themesPointer"></li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span> Buy The Dip within channels, but keep stops tight.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold:</span> Long-term bullish, short-term stretched, don’t chase highs blindly.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span> Supply squeeze brewing; watch Saudi rhetoric.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Volatility:</span> Likely to dictate trade entries/exits in the coming weeks.
                  </p>
                </li>
              </ul>
              <p>
                September is about <span className="highlightedText">nimble trading, not conviction plays.</span> Stay flexible, avoid bias traps, and use the chop to your advantage.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1-lzkU00vY2GMHrGl-ZGt2OpLfBykExc0YDGhkrBY0kA/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog33;
